import React from 'react'

export default function Sidebar() {
  return (
    <>
      <h1>Sidebar</h1>
      <p><span className='tag-grey bold'>.sidebar</span> class creates a vertical bar element. add <span className='tag-grey bold'>.full-sidebar</span> to make the sidebar takes the full height of the screen </p>
      <p>This class comes with several classes that can be added to elements within the navbar to control their position with ease </p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="sidebar"&gt;<br/>
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;/div&gt;
        </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
      <div className="sidebar">
        <div className="navbar-header">header</div>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
        </div>
      </div>

      <h2 className='pt-4'>Sidebar Placements</h2>
      <h3>Code:</h3>
      <p> add <span className='tag-grey bold'>.bar-up</span> class to an element inside the navbar to move it to the top of the navbar</p>
      <p> add <span className='tag-grey bold'>.bar-center</span> class to an element inside the navbar to move it to the center of the navbar</p>
      <p> add <span className='tag-grey bold'>.bar-down</span> class to an element inside the navbar to move it to the bottom of the navbar</p>
      <p>Note: If there are other items that are right beside the element with these added classes, they will also be affected. </p>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="sidebar" style= &#123;&#123;"height": "30rem"&#125;&#125;&gt; <br />
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
          &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;li class="bar-center"&gt;link one&lt;/li&gt;<br/>
          &lt;li class="bar-end"&gt;link one&lt;/li&gt;<br/>
          &lt;li&gt;link one 2&lt;/li&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
      <div className="sidebar" style={{"height": "30rem"}}>
        <div className="navbar-header">header</div>
            <li>link one</li>
            <li>link one</li>
            <li  className="bar-center">link one</li>
            <li className="bar-end">link one</li>
            <li>link one 2</li>
        </div>
      </div>

      <h2>Collapsible Sidebars</h2>
      <p className='italic'>This requires the .js file of this library to function properly</p>
      <p>The data-collapse attribute is compulsory and must match the id of the sidebar content </p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div className="sidebar-collapse"&gt;<br/>
            &lt;div className="sidebar-head"&gt;<br/>
                &lt;div className="sidebar-toogle-button" data-collapse="collapsesideBar"&gt;&lt;/div&gt;<br/>
                &lt;div className="navbrand"&gt;&lt;/div&gt;<br/>
            &lt;/div&gt;<br/>
            &lt;div className="sidebar" id="collapsesideBar"&gt;<br/>
                &lt;li&gt;link one&lt;/li&gt;<br/>
                &lt;li&gt;link one&lt;/li&gt;<br/>
                &lt;li&gt;link one&lt;/li&gt;<br/>
                &lt;li&gt;link one&lt;/li&gt;<br/>
            &lt;/div&gt;<br/>
          &lt;/div&gt;
        </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
      <div className="sidebar-collapse">
        <div className="sidebar-head">
          <div className="sidebar-toogle-button" data-collapse="collapsesideBar"></div>
          <div className="navbrand"></div>
        </div>
        <div className="sidebar" id="collapsesideBar">
          <li>link one</li>
          <li>link one</li>
          <li>link one</li>
          <li>link one</li>
        </div>
        </div>
      </div>
    </>
  )
}
